import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import Breadcrumb from '../components/Breadcrumb';
import { useSearchParams } from 'react-router-dom';
import { useFetch } from '../hook/useFecth';
import ClientesListLayer from '../components/ClientesListLayer';
import ProdutosListLayer from '../components/ProdutosListLayer';
import RelatorioLayer from '../components/RelatorioLayer';
import DashboardLayer from '../components/DashboardLayer';

const DashboardPage = () => {
    
    return (
        <>
            {/* Breadcrumb */}
            <Breadcrumb title="Dashboard" icon="solar:chart-2-outline" />

            {/* UsersListLayer */}
            <DashboardLayer />
        </>
    );
};

export default DashboardPage;
